import { Panel } from '@/app/components/Panel/Panel'
import { ICourse } from '@/types/course'
import { useTranslations } from 'next-intl'

type CourseTargetsProps = {
  courseInfo: Pick<ICourse, 'targets'>
} & React.HTMLAttributes<HTMLDivElement>

export function CourseTargets({ courseInfo, ...props }: CourseTargetsProps) {
  const t = useTranslations('CoursePage')
  const { targets = [] } = courseInfo || {}

  const validTargets = (targets ?? []).filter(
    (target) => target.title && target.description
  )

  if (!validTargets.length) {
    return null
  }

  return (
    <div {...props} className={`${props.className}`}>
      <h2 className="text-sm font-normal leading-6 uppercase text-gray-light font-title">
        {t('who_is_this_course_for')}
      </h2>
      {/* TODO: fill with data*/}
      <div className="relative w-full mt-4 md:mt-8">
        <div className="flex gap-2 px-8 -mx-8 overflow-x-auto ali md:items-start lg:items-stretch md:px-0 md:mx-0 no-scrollbar md:grid md:grid-cols-3">
          {targets.map((item, index) => (
            <Panel
              key={index}
              className="flex flex-col !px-5 !py-3 w-auto flex-shrink-0 max-w-80"
            >
              <p className="font-bold">{item.title}</p>
              <p className="max-w-64">{item.description}</p>
            </Panel>
          ))}
        </div>
      </div>
    </div>
  )
}
